import './Styles.scss'

// Image gallery
const galleryPopup = () => {
    const galleries = document.querySelectorAll('[data-gallery]')

    if (galleries) {
        galleries.forEach(gallery => {
            const lightbox = window.popup.Glightbox({
                selector:   '[data-gallery="' + gallery.dataset.gallery + '"]',
                loop:       true,
                moreLength: 0
            })
        })
    }
}

galleryPopup()